export const SeaFlagActionTypes = {
  API_RESPONSE_SUCCESS: '@@sea-flags/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@sea-flags/API_RESPONSE_ERROR',

  GET_SEA_FLAG: '@@sea-flags/GET_SEA_FLAG',
  LIST_SEA_FLAGS: '@@sea-flags/LIST_SEA_FLAGS',
  ADD_SEA_FLAG: '@@sea-flags/ADD_SEA_FLAG',
  UPDATE_SEA_FLAG: '@@sea-flags/UPDATE_SEA_FLAG',
  DELETE_SEA_FLAG: '@@sea-flags/DELETE_SEA_FLAG',
  SET_FILTER: '@@sea-flags/SET_FILTER',

  RESET: '@@sea-flags/RESET'
}
